// GENERATED by scripts/gen-search-index.mts — do not edit by hand.
// Labels each custom row renders, so search can find controls the schema
// cannot see. Regenerate after changing a custom control.
export const CUSTOM_TERMS: Record<string, string[]> = {
  "renderer.renderer-control": [
    "Custom",
    "Full",
    "Height (0=auto)",
    "Mode",
    "Render Scale",
    "Width (0=auto)"
  ],
  "camera.controlsControl": [
    "Auto Near/Far",
    "Auto Rotate",
    "Auto Rotate Speed",
    "Damping Factor",
    "Dolly FoV",
    "Dolly Zoom",
    "Enable Damping",
    "Enable Pan",
    "Enable Zoom",
    "Enabled",
    "Max Azimuth Angle",
    "Max Distance",
    "Max Far",
    "Max Polar Angle",
    "Max Zoom",
    "Min Azimuth Angle",
    "Min Distance",
    "Min Near",
    "Min Polar Angle",
    "Min Zoom",
    "Pan Speed",
    "Rotate Speed",
    "Zoom Speed",
    "Zoom to Cursor"
  ],
  "materialLibrary.replaceMaterial": [
    "Replace Material"
  ],
  "savedMaterials.savedMetal": [
    "Name"
  ],
  "savedMaterials.savedGem": [
    "Name"
  ],
  "diamonds.diamonds": [
    "Env Rotation",
    "Env Slot (selected)",
    "Environment 2",
    "Environment 3",
    "Oriented Env Map",
    "Use Scene Environment"
  ],
  "transform.transformControl": [
    "Gizmo",
    "Local",
    "Mode",
    "Rotate",
    "Rotate Snap (°)",
    "Scale",
    "Show X",
    "Show Y",
    "Show Z",
    "Size",
    "Space",
    "Translate",
    "Translate Snap",
    "World"
  ],
  "pivotControls.pivot": [
    "Depth Test",
    "Disable Axes",
    "Disable Rotations",
    "Disable Scaling",
    "Disable Sliders",
    "Enabled",
    "Fixed Size",
    "Gizmo Scale",
    "Rotation Snap (deg)",
    "Scale Snap",
    "Translation Snap"
  ],
  "pivotEdit.pivotEdit": [
    "Edit Pivot",
    "Enabled",
    "Marker Color",
    "Marker Scale",
    "Show Pivot Marker"
  ],
  "picker.pickerControl": [
    "Auto Focus",
    "Hover Highlight",
    "Multi-Select",
    "Picking"
  ],
  "widgets.widgets": [
    "Visible"
  ],
  "nodeInspector.node": [
    "Name",
    "Render Order",
    "Visible"
  ],
  "nodeGeometry.geom": [
    "Meshes",
    "Triangles",
    "Vertices"
  ],
  "diamondRayTracing.inclusions": [
    "Bump Scale",
    "BumpScale",
    "ClampHDR",
    "Color",
    "Color Map Scale",
    "Custom Map URL",
    "Enabled",
    "IncNormalScale",
    "InclusionMap",
    "InclusionNormalMap",
    "InclusionRoughness",
    "InclusionScale",
    "Map",
    "None",
    "RoughnessMap",
    "Scale",
    "Surface Roughness",
    "SurfaceScale",
    "VariableBlur",
    "VariableParam1",
    "VariableParam2",
    "blurRadius",
    "normalMap"
  ],
  "materialAdvanced.fullMat": [
    "AO / Lightmap",
    "AO Map Intensity",
    "Alpha Test",
    "Anisotropy",
    "Attenuation Colour",
    "Attenuation Distance",
    "Back",
    "Blending",
    "Bump / Normal",
    "Bump Scale",
    "Clearcoat",
    "Clearcoat Roughness",
    "Color Write",
    "Colors",
    "Colour",
    "Depth Test",
    "Depth Write",
    "Displacement Scale",
    "Double",
    "Emission",
    "Emissive Colour",
    "Emissive Intensity",
    "Env Intensity",
    "Environment",
    "Flat Shading",
    "Front",
    "IOR",
    "Iridescence",
    "Iridescence IOR",
    "Light Map Intensity",
    "Metalness",
    "Normal Scale X",
    "Normal Scale Y",
    "Opacity",
    "Override Environment",
    "Poly Offset Factor",
    "Poly Offset Units",
    "Polygon Offset",
    "Reflectivity",
    "Refraction",
    "Rotation",
    "Rough / Metal",
    "Roughness",
    "Sheen",
    "Sheen Colour",
    "Sheen Roughness",
    "Side",
    "Specular",
    "Specular Colour",
    "Specular Intensity",
    "Thickness",
    "Thickness Max",
    "Thickness Min",
    "Transmission",
    "Transparent"
  ],
  "materialExtensions.ext": [
    "Blend",
    "Bump Scale",
    "Clip Height (Y)",
    "Colored Flakes",
    "Enabled",
    "Factor",
    "Flake Radius",
    "Flake Scale",
    "Intensity",
    "Invert",
    "Make 2D",
    "Scale",
    "Thickness",
    "Tint"
  ],
  "materialExtensions.layered": [
    "Cavity Color",
    "Cavity Metalness",
    "Cavity Roughness",
    "Cavity Scale",
    "Cutoff",
    "Enabled",
    "Step Size"
  ],
  "savedEnvironments.savedEnv": [
    "Name"
  ],
  "environment.backgroundImage": [
    "Background Image"
  ],
  "bgEnvAdvanced.envAdv": [
    "BG Intensity",
    "Color",
    "Env Intensity",
    "Env Rotation",
    "Env1 Rotation",
    "EnvMap BG",
    "Environment1",
    "Fixed Env Direction"
  ],
  "groundFull.groundConfig": [
    "Color",
    "Enabled",
    "Intensity",
    "Metalness",
    "Roughness",
    "Shadow Enabled",
    "Shadow Frames",
    "Size",
    "bias",
    "direction",
    "distanceScale",
    "focus",
    "frustumSize",
    "normalDirection",
    "radius",
    "spread"
  ],
  "progressiveShadow.progressiveShadow": [
    "Color"
  ],
  "randomizedSelfShadow.rss": [
    "Direction",
    "Distance Scale",
    "Enabled",
    "Focus",
    "Spread"
  ],
  "gradientSvg.gradient": [
    "Angle",
    "Apply to Background",
    "Color 1",
    "Color 2",
    "Linear",
    "Radial",
    "Radius",
    "Type"
  ],
  "hdriGround.hdri": [
    "Enabled",
    "Origin Position",
    "Tripod height",
    "World Radius"
  ],
  "sceneLights.lights": [
    "Azimuth",
    "Bias",
    "Blur Samples",
    "Cast Shadow",
    "Colour",
    "Cone Angle",
    "Distance",
    "Elevation",
    "Height",
    "Intensity",
    "Map Size",
    "Normal Bias",
    "Penumbra",
    "Remove light",
    "Shadow Opacity",
    "Shadow Softness",
    "Show helper gizmo",
    "Width"
  ],
  "outline.outlineControl": [
    "Color",
    "Debug",
    "Dynamic Selection",
    "Highlight",
    "Highlight Materials (same name)",
    "Highlight Selected Materials",
    "Intensity",
    "Outline",
    "Transparency"
  ],
  "assetExport.glb": [
    "(name)",
    "Encode Speed",
    "Encrypt Password",
    "Format"
  ],
  "video.videoRow": [
    "Converge mode",
    "Frame Rate",
    "MP4 (else WebM)",
    "Turntable animation CCW"
  ],
  "imageExport.image": [
    "(x, y, w, h)",
    "Auto tile",
    "Crop Rect",
    "Filename",
    "Size",
    "Transparent"
  ],
  "sceneSettings.wholeScene": [
    "Ring + scene (.glb)",
    "Whole scene (.jscene)"
  ],
  "gltf-clips.dragScroll": [
    "Auto Increment Time",
    "Drag Axis",
    "Drag Damping",
    "Scroll Damping"
  ],
  "camera-views.views": [
    "Duration (ms)",
    "Fly to view",
    "Loop All Views",
    "Name",
    "Rename",
    "Rotation Offset",
    "View Pause (ms)"
  ],
  "camera-views.seekOnScroll": [
    "Seek On Scroll"
  ],
  "camera-views.scrollProgress": [
    "Scroll Progress"
  ],
  "scrollCamera.scroll": [
    "Damping",
    "Enable Damping",
    "Enabled"
  ],
  "physics.physics": [
    "Enabled",
    "delta",
    "stepCount"
  ],
  "sceneLoop.loop": [
    "Interval (ms)"
  ],
  "objectRotations.objrot": [
    "Offset",
    "Rotate Around Parent",
    "Rotation Count",
    "Rotation Skips"
  ],
  "extrudeTube.tube": [
    "Enabled",
    "Horizontal Splits",
    "Material Splits",
    "Shape Scale",
    "Shape Segments (X)",
    "Tube Segments (Y)"
  ],
  "simpleText.text": [
    "Apply Alpha Map",
    "Apply Bump Map",
    "Apply Map",
    "Font",
    "Font Size",
    "Font Url",
    "Height",
    "Inner Shadow",
    "Invert Alpha Map",
    "Mask Text",
    "SVG BG",
    "Text",
    "Text Color",
    "Transparent BG",
    "Width",
    "X Offset",
    "Y Offset"
  ],
  "parallaxMapping.parallaxMapping": [
    "Binary search steps",
    "Debug Hit Height",
    "Debug Normals",
    "Enabled",
    "Step count"
  ],
  "parallaxCamera.parallaxCamera": [
    "Damping",
    "Enabled",
    "Invert",
    "Sensitivity"
  ],
  "simplify.simplify": [
    "Error Threshold",
    "Lock Border",
    "Simplify Factor"
  ],
  "variationConfigurator.varcfg": [
    "Config URL"
  ],
  "materialConfigurator.matcfg": [
    "Apply variation",
    "Name",
    "Rename",
    "uuid"
  ],
  "switchNode.switch": [
    "Rename",
    "Title"
  ],
  "loadingScreen.loader": [
    "Background Blur",
    "Background Color",
    "Background Opacity",
    "Error text header",
    "Hide delay (ms)",
    "Loading text header",
    "Logo Image",
    "Text Color"
  ],
  "frameFade.ff": [
    "Enabled"
  ],
  "modelStage.stage": [
    "Ground below model",
    "URL"
  ],
  "watchHands.watch": [
    "Analog",
    "Enabled",
    "Hour match",
    "Hour offset",
    "Invert axis",
    "Minute match",
    "Minute offset",
    "Regex",
    "Second match",
    "Second offset"
  ],
  "css3d.css3d": [
    "Enabled",
    "Over canvas",
    "iframe URL"
  ],
  "snowFall.snow": [
    "Bottom clamp",
    "Bounds size",
    "Enabled",
    "Particle size",
    "Particle speed",
    "Paused"
  ],
  "waveGround.wave": [
    "Amplitude",
    "Enabled",
    "Noise scale",
    "Paused"
  ],
  "rainbowDiamond.rainbow": [
    "Count",
    "First Color",
    "Loops",
    "Object name prefix"
  ]
};
